import app from '../app';

const limitsByCategory = {
    'default': {
        'about-building': 3
    },
};

app.service('segmentFieldsLimitService', ['isSimpleFormEnabled', 'addFormService', function(isSimpleFormEnabled, addFormService) {
    this.hasLimit = (segment) => {
        return !!this.getLimit(segment);
    };

    this.getLimit = (segment) => {
        if (isSimpleFormEnabled()) {
            const limitsInCategory = limitsByCategory[addFormService.ad.category] || limitsByCategory['default'];
            return limitsInCategory[segment];
        }

        return undefined;
    }
}]);
